var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height pa-2 py-0",attrs:{"justify":"center","align":"start"}},[_c('v-col',{staticClass:"pb-0 pt-1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }